import styles from './monthly-report-container.module.scss';
import { Box, Container, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import { useState } from 'react';
import PeriodChurnReport from '../period-churn-report/period-churn-report';
import PageTitle from '../page-title/page-title';
import { Col, Row } from 'reactstrap';
import MonthlyChurnReports from '../monthly-churn-reports/monthly-churn-reports';
import { useTranslation } from 'react-i18next';


/* eslint-disable-next-line */
export interface MonthlyReportContainerProps { }

export function MonthlyReportContainer(props: MonthlyReportContainerProps) {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const navigateToMRR = () => setSelectedTab(0);
  const navigateToARR = () => setSelectedTab(1);
  const navigateToPeriodReport = () => setSelectedTab(2);

  return (
    <Container className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.churn")} subtitle={`(${t("standard.report")})`} />
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
              <Tabs
                value={selectedTab}
                variant="scrollable"
                scrollButtons="auto">
                <Tab label={"MRR"} onClick={navigateToMRR} />
                <Tab label={"ARR"} onClick={navigateToARR} />
                <Tab label={t("standard.period")} onClick={navigateToPeriodReport} />
              </Tabs>
            </Box>
            {selectedTab === 0 && <MonthlyChurnReports url="reports/action/getMonthlyChurn" />}
            {selectedTab === 1 && <MonthlyChurnReports url="reports/action/getYearlyChurn" />}
            {selectedTab === 2 && <PeriodChurnReport />}
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default MonthlyReportContainer;